export enum API_REQUEST_HEADER {
    current_organisation_id = 'Current-Organisation-Id',
    firebase_token = 'Firebase-Token',
    trace_id = 'X-Trace-Id',
    app_version = 'X-App-Version',
    mobile_app_version = 'Mobile-App-Version',
    form_id = 'X-Form-Id',
}
